import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import WeekColumn from './WeekColumn';
import FutureDeliveries from './FutureDeliveries';

const OrdersHistory = ({
    productId,
    rowIndex,
    providerError,
    isTable = false,
    productsDeliveries,
}) => {
    const productDeliveries = productsDeliveries.get(productId);

    if (!productDeliveries) {
        return null;
    }

    if (providerError) {
        return rowIndex === 0 ? (
            <span>
                History orders <br />
                could not be retrieved.
            </span>
        ) : null;
    }

    const { weeks, in_delivery } = productDeliveries;

    return (
        <div
            className={`d-flex flex-row-reverse ${
                isTable ? 'orders-histories' : ''
            }`}
        >
            <div
                className="flex-center"
                style={{ paddingTop: isTable ? '0' : '35px' }}
            >
                {weeks.map((weekData) => (
                    <WeekColumn
                        key={weekData.name}
                        week_name={weekData.name}
                        quantity={weekData.quantity}
                        is_current={weekData.isCurrent}
                    />
                ))}
            </div>
            <FutureDeliveries inDelivery={in_delivery} />
        </div>
    );
};

OrdersHistory.propTypes = {
    weeks: PropTypes.array,
    inDelivery: PropTypes.array,
    productsDeliveries: PropTypes.object,
};

const mapStateToProps = (state) => ({
    productsDeliveries: state.productsDeliveries.data,
});

export default connect(mapStateToProps)(OrdersHistory);
